module.exports = __webpack_public_path__ + "static/media/GEM-daylight.9062a93f.jpg";